import Header from '../../../../components/Header';
import Footer from '../../../../components/Footer/Footer';
import HomeNav from '../../../../components/HomeNav';
import { SINavbar } from '../../../../components/Tools/Navbar/Navbar';
import { Breadcrumb, Tab, Tabs, Table } from 'react-bootstrap';
import { FaHome } from 'react-icons/fa';
import InspectionFrame from '../assets/equipment/3.2-typical-safety-barrier.png';
import BarrierLocations from '../assets/equipment/3.3-barrier-locations.png';
import CameraMountAssembly from '../assets/equipment/3.4-frame-assembly-cameras.png';
import CameraMountAssembly2 from '../assets/equipment/3.5-frame-assembly-cameras-2.png';
import Camera201 from '../assets/equipment/3.6-camera-set-201.png';
import ParallelClamp from '../assets/equipment/3.7-parallel-vertical-frame-clamp.png';
import CameraAssembly from '../assets/equipment/3.8-camera-assembly.png';
import AlliedVision from '../assets/equipment/3.9-allied-vision-alvium-g5.png';
import Single600Lights from '../assets/equipment/3.10-600-single-lights.png';
import Double700Lights from '../assets/equipment/3.11-700-double-lights.png';
import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { BsPencil } from 'react-icons/bs';
import PDPDrawing from '../../../../components/Tables/Tabledata/Drawings/IE-2470-110.pdf';
import CameraMountDrawing from '../../../../components/Tables/Tabledata/Drawings/CMA.zip';
import SingleWideDrawing from '../../../../components/Tables/Tabledata/Drawings/IO-2470-600.PDF';
import DoubleWideDrawing from '../../../../components/Tables/Tabledata/Drawings/IO-2470-700.PDF';

import 'bootstrap/dist/css/bootstrap.min.css';

const WarrenAssemblies = () => {
	const location = useLocation();

	useEffect(() => {
		const queryParams = new URLSearchParams(location.search);
		const activeTab = queryParams.get('tab');

		if (activeTab) {
			setActiveKey(activeTab);
		}
	}, [location]);

	const [activeKey, setActiveKey] = useState('Inspection Frame Assembly');
	return (
		<>
			<Header plant="warren" />
			<main>
				<HomeNav plant="warren" />
				<wrapper class="section-wrapper">
					<SINavbar />
					<container class="section-container">
						<Breadcrumb>
							<Breadcrumb.Item href="/smart-inspect/warren/overview">
								<FaHome size={20} />
							</Breadcrumb.Item>
							<Breadcrumb.Item active>Equipment</Breadcrumb.Item>
							<Breadcrumb.Item active>Assemblies</Breadcrumb.Item>
						</Breadcrumb>
						<content class="section-content">
							<Tabs activeKey={activeKey} onSelect={setActiveKey} className="mb-3 equipment-element">
								<Tab eventKey="Inspection Frame Assembly" title="Inspection Frame Assembly">
									<div class="tab-section" style={{ display: 'flex' }}>
										<div class="left-side">
											<div class="d-flex">
												<h2>INSPECTION FRAME ASSEMBLY</h2> <a href="#" target="_blank"></a>
											</div>
											<p>The cell uses structural welded beams to support the camera and lighting assemblies. The overall framework is covered by the Cell Frame Covering (vinyl panels) to protect the camera equipment and shield personnel from the bright LED lighting during scan sequences. The entrance and exit points are blocked on either side of the plant conveyor with short, tubular barriers to prevent personnel from hazardous equipment motions.</p>
											<img src={BarrierLocations} alt="Master Key Box" style={{ width: '100%' }} />
											<figcaption>Figure 1: Barrier Locations</figcaption>
										</div>

										<div class="right-side">
											<figure>
												<img src={InspectionFrame} alt="Master Key Box" style={{ width: '95vh' }} />
												<figcaption>Figure 2: Typical Safety Barrier</figcaption>
											</figure>
										</div>
									</div>
								</Tab>

								<Tab eventKey="Camera Mounting Assemblies" title="Camera Mounting Assemblies">
									<div class="tab-section" style={{ display: 'flex', justifyContent: 'space-between' }}>
										<div class="left-side" style={{ width: '50vw' }}>
											<div class="d-flex">
												<h2>CAMERA MOUNTING ASSEMBLIES</h2>{' '}
												<a href={CameraMountDrawing} target="_blank">
													<button style={{ padding: '5px', margin: '0 10px', borderRadius: '.5rem', background: '#4c1b7dd1' }}>
														<BsPencil size={30} color="white" />
													</button>
												</a>
											</div>
											<p>The Camera Mounting Assemblies are comprised of extruded channels onto which are mounted octagonal booms containing the various camera mounting brackets which provide for precise camera alignment.</p>
											<p>The following figures help to illustrate the typical Camera Mounting Assemblies in use on the machine.</p>
											<div class="img-box" style={{ display: 'flex' }}>
												<figure style={{ margin: '10px', width: '16vw' }}>
													<img src={CameraMountAssembly} alt="Master Key Box" style={{ width: '100%', margin: '0 auto', display: 'block' }} />
													<figcaption>Figure1: Frame Assembly Camera/Lighting – Part Going View</figcaption>
												</figure>
												<figure style={{ margin: '5px 20px', width: '16vw' }}>
													<img src={Camera201} alt="Master Key Box" style={{ width: '100%', margin: '0 auto', display: 'block' }} />
													<figcaption>Figure 2: Camera Set 201</figcaption>
												</figure>
												<figure style={{ margin: '10px', width: '16vw' }}>
													<img src={ParallelClamp} alt="Master Key Box" style={{ width: '100%', margin: '0 auto', display: 'block' }} />
													<figcaption>Figure 3: Parallel and Vertical Frame Clamp Assembly Example</figcaption>
												</figure>
											</div>
										</div>

										<div class="right-side">
											<figure>
												<img src={CameraMountAssembly2} alt="Master Key Box" style={{ width: '100%' }} />
												<figcaption>Figure 4: Frame Assembly Camera/Lighting – Part Going View</figcaption>
											</figure>
										</div>
									</div>
								</Tab>

								<Tab eventKey="Camera Assemblies" title="Camera Assemblies">
									<div class="tab-section" style={{ display: 'flex' }}>
										<div class="left-side" style={{ width: '40vw' }}>
											<div class="d-flex">
												<h2>CAMERA ASSEMBLIES</h2>{' '}
												<a href={PDPDrawing} target="_blank">
													<button style={{ padding: '5px', margin: '0 10px', borderRadius: '.5rem', background: '#4c1b7dd1' }}>
														<BsPencil size={30} color="white" />
													</button>
												</a>
											</div>
											<p>Camera assemblies come in 16mm, 25mm, and 35mm Focal Lengths. Each consists of an Allied Vision Alvium G5 camera with lens, mounting bracket, transitional bracket and boom for frame attachment and positioning. Each is numbered for clear identification.</p>
											<figure style={{ width: '30vw', margin: '20px' }}>
												<img src={AlliedVision} alt="Master Key Box" style={{ width: '100%' }} />
												<figcaption>Figure 1: Allied Vision Alvium G5 Camera</figcaption>
											</figure>
										</div>

										<div class="right-side">
											<figure style={{ width: '40vw' }}>
												<img src={CameraAssembly} alt="Master Key Box" style={{ width: '100%' }} />
												<figcaption>Figure 2: Camera Assembly Examples</figcaption>
											</figure>
										</div>
									</div>
								</Tab>

								<Tab eventKey="Lighting Assemblies" title="Lighting Assemblies">
									<div class="tab-section" style={{ display: 'flex' }}>
										<div class="left-side">
											<div class="d-flex">
												<h2>LIGHTING ASSEMBLIES</h2>{' '}
												<a href={SingleWideDrawing} target="_blank">
													<button style={{ padding: '5px', margin: '0 10px', borderRadius: '.5rem', background: '#4c1b7dd1' }}>
														<BsPencil size={30} color="white" />
													</button>
												</a>
												<a href={DoubleWideDrawing} target="_blank">
													<button style={{ padding: '5px', margin: '0 10px', borderRadius: '.5rem', background: '#4c1b7dd1' }}>
														<BsPencil size={30} color="white" />
													</button>
												</a>
											</div>
											<p>The lighting Assemblies incorporate the single or double-width LED light source, 480W LED Driver, light bar clamps, transition bracket and boom, for attaching and positioning onto the frame assembly.</p>
											<div class="img-box" style={{ display: 'flex' }}>
												<figure style={{ width: '30vw' }}>
													<img src={Single600Lights} alt="Master Key Box" style={{ width: '100%' }} />
													<figcaption>Figure 1: 600 Single Width Light Assembly</figcaption>
												</figure>
												<figure style={{ width: '30vw' }}>
													<img src={Double700Lights} alt="Master Key Box" style={{ width: '100%' }} />
													<figcaption>Figure 2: 700 Double Width Light Assembly</figcaption>
												</figure>
											</div>
										</div>
									</div>
								</Tab>
							</Tabs>
						</content>
					</container>
				</wrapper>
			</main>
			<Footer />
		</>
	);
};

export default WarrenAssemblies;
